import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Certificates from "./pages/Certificates";
import PageNotFound from "./pages/PageNotFound";

import ProjectsIndex from "./pages/projects/Index";
import ProjectDetails from "./pages/projects/ProjectDetails";

import MyNavBar from "./components/MyNavBar";

function App() {
  return (
    <Router>
      <MyNavBar />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route
          path="/projects/home"
          element={<ProjectsIndex />}
        />

        <Route
          path="/projects/:slug"
          element={<ProjectDetails />}
        />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/certificates"
          element={<Certificates />}
        />

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;

